module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "status"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('h2', {
    staticClass: "text-center loading"
  }, [_vm._v("Loading Data")])]) : _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [(_vm.selectedEnrollment) ? _c('div', _vm._l((_vm.selectedEnrollment.letters), function(letter) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadLetter(letter.url)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(letter.type.split('_')[0])) + " Letter"), (letter.programId) ? _c('span', [_vm._v(" - " + _vm._s(_vm.getProgramName(letter.programId)))]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.documents), function(document) {
    return _c('div', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadSlip(document)
        }
      }
    }, [_vm._v(_vm._s(document.type))])])
  })], 2), _vm._v(" "), _vm._l((_vm.projects), function(project, $index) {
    return _c('div', {
      staticClass: "form-group"
    }, [(project.passed === true && _vm.selectedEnrollment.program.venue === 'online') ? _c('div', {
      staticClass: "diploma-links"
    }, [_c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.localStorage.account_id + '.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                                Digital Credentials (dark)\n                            ")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.localStorage.account_id + '_print.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                                Digital Credentials (light)\n                            ")])]) : _vm._e()])
  }), _vm._v(" "), (_vm.loaded) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "zoom-status"
  }, [_c('div', {
    staticClass: "indicator",
    class: {
      'red': !_vm.zoomAccountConnected, 'green': _vm.zoomAccountConnected
    }
  }), _vm._v(" "), (_vm.zoomAccountConnected) ? _c('span', [_vm._v("Zoom account connected")]) : _c('span', [_vm._v("Zoom account not connected -- please contact support")])])]) : _vm._e(), _vm._v(" "), (_vm.programId !== '1d8cb5a0-13b5-4ee1-a9a7-9c29566c0bbc') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Your Picks")]), _vm._v(" "), (this.path != '9200') ? _c('div', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pick Your Path:")]), _vm._v(" "), (_vm.pathName) ? _c('span', [_vm._v(_vm._s(_vm.pathName))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pick Your Mentor: ")]), _vm._v(" "), (_vm.mentorName) ? _c('span', [_vm._v(_vm._s(_vm.mentorName))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.metrics) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("All Transcripts")]), _vm._v(" "), (_vm.enrollments) ? _c('div', {
    staticClass: "download-transcript"
  }, _vm._l((_vm.enrollments), function(enrollment) {
    return _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getTranscript(enrollment)
        }
      }
    }, [_vm._v("\n                                Download Transcript for " + _vm._s(enrollment.program.name) + " – " + _vm._s(_vm._f("monthAndYear")(enrollment.intake)) + "\n                            ")])
  })) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Your Marks")]), _vm._v(" "), _c('div', {
    staticClass: "metrics-container"
  }, _vm._l((_vm.metrics), function(metric) {
    return (metric.term.type !== 'mentorship') ? _c('div', {
      staticClass: "term-metrics"
    }, [_c('div', {
      staticClass: "term-header",
      on: {
        "click": function($event) {
          _vm.toggleTerm(metric.term.id)
        }
      }
    }, [(_vm.selectedTerms.includes(metric.term.id)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    }), _vm._v("\n                                    " + _vm._s(metric.term.name) + "\n                                    "), (new Date(metric.term.endDate) < new Date()) ? _c('span', {
      staticClass: "total-mark"
    }, [_vm._v("\n                                        " + _vm._s(metric.totalMark) + "%  " + _vm._s(_vm.letterGrade(metric.totalMark)) + "\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedTerms.includes(metric.term.id)),
        expression: "selectedTerms.includes(metric.term.id)"
      }],
      staticClass: "metrics"
    }, [_c('div', [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("10% Live Session Attendance")]) : _c('span', {
      staticClass: "bold"
    }, [_vm._v("25% Metrics")]), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("10% Video Progress: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.video.mark) + "% " + _vm._s(metric.video.progress) + " / " + _vm._s(metric.video.totalDuration))])]) : _vm._e(), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("5% Forum / Chat: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.interactions.mark) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("Attendance: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.meetings.attended) + " / " + _vm._s(metric.meetings.total))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.toggleAssignments(metric.term.id)
        }
      }
    }, [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("40% Assignments:")]) : _c('span', {
      staticClass: "bold"
    }, [_vm._v("25% Assignments:")]), _vm._v(" "), (_vm.selectedAssignments.includes(metric.term.id)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })]), _vm._v(" "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.assignments.mark) + "%")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedAssignments.includes(metric.term.id)),
        expression: "selectedAssignments.includes(metric.term.id)"
      }],
      staticClass: "submissions"
    }, _vm._l((metric.assignments.assignments), function(assignment) {
      return _c('div', [_vm._v("                                                \n                                                Week " + _vm._s(assignment.week) + ":\n                                                "), (assignment.instance['associated.name']) ? _c('span', [_vm._v(_vm._s(assignment.instance['associated.name']))]) : _vm._e(), _vm._v("\n                                                – " + _vm._s(assignment.name) + "\n                                                "), _vm._v(" "), (assignment.submission) ? _c('span', {
        staticClass: "mark"
      }, [(assignment.submission.grade == null) ? _c('span', [_vm._v("Ungraded")]) : _c('span', [_vm._v(_vm._s(assignment.submission.grade))]), _vm._v(" "), (assignment.submission.grade != null) ? _c('span', [_vm._v("%")]) : _vm._e()]) : _c('span', {
        staticClass: "mark"
      }, [_vm._v("Incomplete")])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("50% Final Project:")]), _vm._v(" "), (metric.finalProject && new Date(metric.term.endDate) < new Date()) ? _c('span', {
      staticClass: "mark"
    }, [(metric.finalProject.submission && isNaN(metric.finalProject.mark)) ? _c('span', [_vm._v("Ungraded")]) : _vm._e(), _vm._v(" "), (!metric.finalProject.submission) ? _c('span', [_vm._v("Incomplete")]) : _vm._e(), _vm._v(" "), (metric.finalProject.submission && metric.finalProject.mark) ? _c('span', [_vm._v("\n                                                " + _vm._s(metric.finalProject.mark) + "%\n                                            ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
  }))]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.showOverlay) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }, [_c('div', {
    staticClass: "not-allowed"
  }, [_c('span', {
    staticClass: "close"
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    The ability to change your status is currently closed, please check your \n                    "), _c('router-link', {
    attrs: {
      "to": "/journey"
    }
  }, [_vm._v("Journey")]), _vm._v(" for when it will open."), _c('br'), _c('br'), _vm._v("\n                    If you need to make any changes outside our status window, please create \n                    a "), _c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_vm._v("Financial Ticket")]), _vm._v(" and outline your situation.                    \n                ")], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showStatusChangePopup) ? _c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        _vm.showStatusChangePopup = false
      }
    }
  }, [_c('div', {
    staticClass: "not-allowed"
  }, [_c('span', {
    staticClass: "close"
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('p', [_vm._v("Thank you for updating your status. The next step in your process will be to have a meeting with John Robertson, Head of Admissions, who will guide you through the next steps of the process.")]), _vm._v(" "), _vm._m(1)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("My Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("He will be reaching out to you in the next 48 hours to set a meeting time. If you'd like to reach out to him directly, his email is "), _c('a', {
    attrs: {
      "href": "mailto:john@tttc.ca"
    }
  }, [_vm._v("john@tttc.ca")]), _vm._v(".")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3dc5ac9c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Status.vue
// module id = 2024
// module chunks = 2